<app-user-consent *ngIf="!userConsent"></app-user-consent>
<div class="content">
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
</div>
